// extracted by mini-css-extract-plugin
module.exports = {"container":"HeaderSlot_container__1xcAp","leftIcon":"HeaderSlot_leftIcon__18cWH"};